/* eslint-disable react/no-array-index-key */
import {ToggleButton, ToggleButtonGroup, Typography, css, useTheme} from '@mui/material';
import {GetStylesFunction, TranslateUtils} from '@wallaby-ui/core';
import classNames from 'classnames';
import React, {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';

import lightFilterNodeStyles from './LightFilterNodeStyles.less';

type Config = {
  name: string;
};

type Option = {id?: string; name?: string; label?: string; messageKey?: string};
type NormalizedOption = {id: string; label?: string};
type Props = {
  config: Config;
  options: Option[];
  value: string | null | undefined;
  onChange?: (newValue: string) => void;
  style?: React.CSSProperties;
};
export const LightToggleFilter: React.FC<Props> = (props) => {
  const {config: _config, options: _options, value, onChange, style} = props;
  const config = {
    ..._config,
    ui: {..._config.ui},
  };
  const intl = useIntl();
  const options: NormalizedOption[] = useMemo(() => {
    return (_options ?? []).map((option) => ({
      id: String(option.id ?? option.name),
      label: option.messageKey ? TranslateUtils.translate(option.messageKey, intl) : option.label,
    }));
  }, [_options, intl]);
  const changeFilter = useCallback(
    (newValue: string) => {
      if (onChange) onChange(newValue);
    },
    [onChange]
  );
  const theme = useTheme();
  const muiStyles = getStyles({theme});
  return (
    <span
      style={style}
      className={classNames(lightFilterNodeStyles.dlFilterNodeContent, 'dlFilterNode')}
      css={muiStyles.toggleFilterNode}
      data-name={config.name}
    >
      <ToggleButtonGroup orientation='horizontal' value={value} exclusive onChange={(event, newValue) => changeFilter(newValue)} fullWidth>
        {options.map((v, i) => {
          const isSelected = v.id === value;
          return (
            <ToggleButton key={i} value={v.id} aria-label={v.label} css={muiStyles.toggleButton} data-selected={isSelected}>
              <Typography variant='value'>{v.label}</Typography>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </span>
  );
};
const getStyles: GetStylesFunction = (options) => {
  return {
    toggleFilterNode: css`
      max-width: 362px;
      padding: 4px 0;
      & .MuiToggleButtonGroup-root {
        width: 100%;
      }
      & .MuiToggleButton-root:first-of-type {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
      & .MuiToggleButton-root:last-of-type {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `,
    toggleButton: css`
      padding: 10px;
      color: var(--dlTheme-700);
      &:hover {
        background: var(--dlThemeGray-300);
      }
      &[data-selected='true'] {
        background: var(--dlTheme-100);
        color: var(--dlTheme-500);
        &:hover {
          background: var(--dlTheme-300);
        }
      }
    `,
  };
};
